window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};

window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

function initProductFormQuickOrder(props) {
  const { OProductFormType } = BSS_B2B.enum;
  const { productSubject } = props;
  productSubject.initProductFormByType(OProductFormType.QUICK_ORDER_LIST);
  BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
}
window.BSS_B2B.addAction('custom:quickview/quickOrderListForm', initProductFormQuickOrder);

function customCompareTd(comparePrice, props) {
  const { variant } = props;
  const existCustomer = BSS_B2B?.shopData?.customer?.id;
  if (!existCustomer) {
    return variant.compare_at_price ?? null;
  }
  return comparePrice;
}
window.BSS_B2B.addFilter('custom:comparePrice/td', customCompareTd);

const addTaxLabelSpan = (input) => input.replace(/((excl|incl)\. btw)/, '<span class="taxlabel">$1</span>');

function customPriceTd(props) {
  const {
    priceElement,
    priceHasVat,
    priceNoVat,
    comparePriceHasVat,
    comparePriceNoVat
  } = props;

  const existCustomer = BSS_B2B?.shopData?.customer?.id;

  if (!existCustomer && (comparePriceHasVat || comparePriceNoVat)) {
    const updatePrice = () => {
      priceElement.innerHTML = `
        ${addTaxLabelSpan(comparePriceNoVat) || ''}${addTaxLabelSpan(comparePriceHasVat) || ''}
        ${addTaxLabelSpan(priceNoVat) || ''}${addTaxLabelSpan(priceHasVat) || ''}
      `;
    };

    updatePrice();

    const observer = new MutationObserver(() => {
      updatePrice();
    });

    observer.observe(priceElement, { childList: true, subtree: true });
  }
}
window.BSS_B2B.addAction('custom:TdProduct/showPriceBase', customPriceTd);

if (typeof BSS_B2B !== 'undefined') {
  if (window.location.pathname.includes("/products")) {
    setTimeout(() => {
      const targetVariants = document.querySelectorAll(".variant-item");
      targetVariants.forEach((variant) => {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          for (const record of recordList) {
            if (record.target.classList.contains("variant-item")) {
              setTimeout(() => {
                BSS_B2B.cp?.utils.init();
                BSS_B2B.td?.utils.init();
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
              }, 1000);
              break;
            }
          }
        });
        mutationObserver.observe(variant, { childList: true, subtree: true });
      });
    }, 500);
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
     if (BSS_B2B) {
       let deliveryMethod = localStorage.getItem("delivery_method")
       if (deliveryMethod) {
         BSS_B2B.sr.status = JSON.parse(deliveryMethod)
       }
       const srStatus = BSS_B2B.sr.status
       if (srStatus) {
         document.querySelector(".delivery-method .pickup").removeAttribute("checked")
         document.querySelector(".delivery-method .shipping").setAttribute("checked", true)
       } else {
         document.querySelector(".delivery-method .shipping").removeAttribute("checked")
         document.querySelector(".delivery-method .pickup").setAttribute("checked", true)
       }
       document.querySelectorAll('input[name="deliveryOption"]').forEach(radio => {
          radio.addEventListener('change', function() {
              BSS_B2B.sr.status = this.value === "shipping";
              localStorage.setItem("delivery_method", JSON.stringify(BSS_B2B.sr.status))
          });
       });
     }
});